export const getAvatarText = (name: string) => {
  try {
    const words = name.trim().split(' ').filter(Boolean);

    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }

    return words
      .slice(0, 2)
      .map(word => word[0].toUpperCase())
      .join('');
  } catch (error) {
    const computedError = error instanceof Error ? error.message : error;
    console.error('Eror during call function getAvatarText: ', computedError);
    return 'N/A';
  }
};

export const getNameFontSize = (size: number) => {
  const LARGE_SIZE_THRESHOLD = 100;
  const MEDIUM_SIZE_THRESHOLD = 50;

  if (size > LARGE_SIZE_THRESHOLD) {
    return 28;
  }
  if (size > MEDIUM_SIZE_THRESHOLD) {
    return 20;
  }
  return 14;
};
